import axios from 'axios';

export const getReports = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsBonuses = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/bonuses`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/variableRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesInsurancesTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/insuranceRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesEnergyTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/energyFeeRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesRecurrentEnergyTotals = async (
  props
) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/recurrentEnergyFeeRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesSignalTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/signalRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesSubAdminsTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/variableRevenuesSubAdmin/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getBalancePreviousYearsTotals = async (props) => {
  const { year, number, newToken, profileId, forUserView = false } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/previousYears/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getCondoReports = async (props) => {
  const { year, number, newToken, condoId, condoVatCode, forUserView } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/condo/${condoId}`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        condoVatCode,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenues = async (props) => {
  const {
    limit,
    offset,
    newToken,
    profileId,
    year,
    accountabilityYear,
    accountabilityMonth,
    supplier,
    number,
    paid,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/variableRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        accountabilityYear,
        accountabilityMonth,
        supplier,
        number,
        paid,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getCondoReportsVariableRevenues = async (props) => {
  const {
    limit,
    offset,
    newToken,
    condoId,
    condoVatCode,
    year,
    accountabilityYear,
    accountabilityMonth,
    supplier,
    number,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/condo/${condoId}/variableRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        accountabilityYear,
        accountabilityMonth,
        supplier,
        number,
        condoVatCode,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesNetwork = async (props) => {
  const {
    limit,
    offset,
    newToken,
    profileId,
    year,
    accountabilityYear,
    accountabilityMonth,
    dateMonth,
    supplier,
    adminQuery,
    number,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${profileId}/variableRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        accountabilityYear,
        accountabilityMonth,
        dateMonth,
        supplier,
        adminQuery,
        number,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesAdmin = async (props) => {
  const {
    limit,
    offset,
    year,
    search,
    subAdminsInvoicesSupplier,
    subAdminsInvoicesNumber,
    subAdminsInvoicesAdmin,
    subAdminsInvoicesAccountabilityYear,
    subAdminsInvoicesAccountabilityMonth,
    newToken,
    profileId,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/variableRevenuesSubAdmin`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        search,
        subAdminsInvoicesSupplier,
        subAdminsInvoicesNumber,
        subAdminsInvoicesAdmin,
        subAdminsInvoicesAccountabilityYear,
        subAdminsInvoicesAccountabilityMonth,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesInsurances = async (props) => {
  const {
    limit,
    offset,
    year,
    insuranceStartMonth,
    insuranceEndYear,
    insuranceEndMonth,
    policy_code,
    admin_cf,
    supplier,
    customer,
    customerType,
    active,
    newToken,
    profileId,
    agencyType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/insuranceRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        insuranceStartMonth,
        insuranceEndYear,
        insuranceEndMonth,
        policy_code,
        admin_cf,
        supplier,
        customer,
        customerType,
        active,
        agencyType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getCondoReportsVariableRevenuesInsurances = async (props) => {
  const {
    limit,
    offset,
    year,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    newToken,
    condoId,
    condoVatCode,
    agencyType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/condo/${condoId}/insuranceRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        insuranceStartMonth,
        policy_code,
        admin_cf,
        customer,
        customerType,
        active,
        condoVatCode,
        agencyType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesInsurancesNetwork = async (props) => {
  const {
    limit,
    offset,
    year,
    insuranceStartYear,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    newToken,
    profileId,
    agencyType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${profileId}/insuranceRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        insuranceStartYear,
        insuranceStartMonth,
        policy_code,
        admin_cf,
        customer,
        customerType,
        active,
        agencyType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesEnergy = async (props) => {
  const {
    limit,
    offset,
    search,
    year,
    energyPod,
    energyCondoVat,
    energyAccountabilityYear,
    energyAccountabilityMonth,
    customerType,
    profileId,
    newToken,
    forUserView = false,
    contractType,
    partnerEonType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/energyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        search,
        year,
        energyPod,
        energyCondoVat,
        energyAccountabilityYear,
        energyAccountabilityMonth,
        customerType,
        forUserView,
        contractType,
        partnerEonType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getCondoReportsVariableRevenuesEnergy = async (props) => {
  const {
    limit,
    offset,
    search,
    year,
    energyPod,
    energyCondoVat,
    energyAccountabilityYear,
    energyAccountabilityMonth,
    condoId,
    condoVatCode,
    newToken,
    forUserView,
    contractType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/condo/${condoId}/energyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        search,
        year,
        energyPod,
        energyCondoVat,
        energyAccountabilityYear,
        energyAccountabilityMonth,
        condoVatCode,
        forUserView,
        contractType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesEnergyNetwork = async (props) => {
  const {
    limit,
    offset,
    search,
    year,
    energyPod,
    energyCondoVat,
    energyAccountabilityYear,
    energyAccountabilityMonth,
    profileId,
    newToken,
    customerType,
    forUserView,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${profileId}/energyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        search,
        year,
        customerType,
        energyPod,
        energyCondoVat,
        energyAccountabilityYear,
        energyAccountabilityMonth,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesRecurrentEnergy = async (props) => {
  const {
    limit,
    offset,
    year,
    search,
    energyRecurrentPod,
    energyRecurrentCondoVat,
    energyRecurrentAccountabilityYear,
    energyRecurrentAccountabilityMonth,
    newToken,
    customerType,
    profileId,
    forUserView = false,
    contractType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/recurrentEnergyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        search,
        customerType,
        energyRecurrentPod,
        energyRecurrentCondoVat,
        energyRecurrentAccountabilityYear,
        energyRecurrentAccountabilityMonth,
        forUserView,
        contractType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getCondoReportsVariableRevenuesRecurrentEnergy = async (props) => {
  const {
    limit,
    offset,
    year,
    search,
    energyRecurrentPod,
    energyRecurrentCondoVat,
    energyRecurrentAccountabilityYear,
    energyRecurrentAccountabilityMonth,
    newToken,
    condoId,
    condoVatCode,
    forUserView = false,
    contractType,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/condo/${condoId}/recurrentEnergyFeeRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        limit,
        offset,
        year,
        search,
        energyRecurrentPod,
        energyRecurrentCondoVat,
        energyRecurrentAccountabilityYear,
        energyRecurrentAccountabilityMonth,
        condoVatCode,
        forUserView,
        contractType,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getReportsVariableRevenuesSignals = async (props) => {
  const {
    admin,
    signalman,
    condo,
    year,
    accountabilityMonth,
    notes,
    signalTypeCode,
    limit,
    offset,
    newToken,
    profileId,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/reports/${profileId}/signalRevenues`,
      headers: {
        Authorization: newToken,
      },
      params: {
        admin,
        signalman,
        condo,
        year,
        accountabilityMonth,
        signalTypeCode,
        notes,
        limit,
        offset,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const inviteToInvoice = async ({ newToken, data }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/invite-to-invoice`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const createBonus = async ({ newToken, bonus }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/bonuses`,
      data: bonus,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const createBonusCommercial = async ({ newToken, bonus, year }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/network/bonuses/${year}`,
      data: bonus,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const deleteBonus = async ({ newToken, _id }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/bonuses/${_id}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const updateBonus = async ({ newToken, data = {} }) => {
  const { _id, date = '', invoiceRef = '', accountability, adminDate } = data;

  try {
    const response = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_API_URL}/bonuses/${_id}`,
      headers: {
        Authorization: newToken,
      },
      data: { date, invoiceRef, accountability, adminDate },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getBonuses = async ({ newToken, query = {}, _id }) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/bonuses/${_id}`,
      headers: {
        Authorization: newToken,
      },
      params: query,
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getAllBonuses = async ({ newToken, query = {} }) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/bonuses`,
      headers: {
        Authorization: newToken,
      },
      params: query,
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getAllOverdueInvoices = async ({ newToken, query = {} }) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/overdue-invoices`,
      headers: {
        Authorization: newToken,
      },
      params: query,
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const addBonusPaymentDate = async ({ newToken, data = {} }) => {
  const { bonusId, date } = data;

  try {
    const response = await axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API_URL}/bonuses/${bonusId}`,
      headers: {
        Authorization: newToken,
      },
      data: { date },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};
